const REQUIRED_MARKER = /\*\s*$/;

/** Required if flagged explicitly or if the visible label ends in an asterisk (e.g. "First name*"). */
export const isRequiredLabel = (label?: string, required?: boolean): boolean =>
  Boolean(required) ||
  (typeof label === "string" && REQUIRED_MARKER.test(label));
